import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

/** Skeleton for panel content area. */
export default function PanelSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 3 }}>
      <Skeleton variant="text" width="60%" height={28} />
      <Skeleton variant="rectangular" height={80} />
      <Skeleton variant="text" width="80%" />
      <Skeleton variant="text" width="40%" />
      <Skeleton variant="rectangular" height={120} />
    </Box>
  );
}
